<template>
  <div>
    <div :class="{'nav-sub': true, 'fixedNavbar':isfixTab}" id="nav-sub">
			<ul class="nav-sub-ul clearfix">
			<li>
				<router-link to="/home/introduce" exact>
					<span v-if="activityType==1">活动介绍</span>
					<span v-if="activityType==2">赛道介绍</span>
				</router-link>
			</li>
			<li>
				<router-link to="/home/task">
					<span v-if="activityType==1">活动任务</span>
					<span v-if="activityType==2">赛道任务</span>
				</router-link>
			</li>
			<li><router-link to="/home/questions">常见问题</router-link></li>
			</ul>
		</div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data(){
    return {
		isfixTab: false,
		offsetTop: '',
		navTop: '',
		activityType: ''
	}
  },
  components: {
  },
  methods: {
    handleTabFix(){
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      var offsetTop = document.querySelector('#nav-sub').offsetTop
      this.offsetTop = offsetTop -89
      scrollTop > this.offsetTop ? this.isfixTab = true : this.isfixTab = false
    }
  },
  mounted(){
    this.navTop = document.querySelector('#nav-sub').offsetTop
    window.addEventListener('scroll', this.handleTabFix, true)
  },
  //离开当前组件前一定要清除滚动监听，否则进入其他路由会报错
  beforeRouteLeave (to, from, next) {
      window.removeEventListener('scroll', this.handleTabFix, true)
      next()
  },
  created(){
	let activityType = localStorage.getItem('activityType')
	this.activityType = activityType
  },
  watch: {
    $route(){
      if(this.isfixTab){
        window.scrollTo(0,this.navTop-268)
      } else {
        window.scrollTo(0,this.navTop)
      }
    }
  }
}
</script>

<style scoped lang="less">
.nav-sub{width:1200px; height: 89px; box-shadow: 0px 3px 12px 0px rgba(217, 217, 217, 0.47); overflow: hidden;}
/* .nav-sub-ul{width:92%;max-width:1150px;margin:0 auto;} */
.nav-sub-ul{width:1200px;margin:0 auto;}
.nav-sub-ul li{float: left; margin-right:10%; font-size: 20px; font-weight: bold; line-height: 86px;}
.nav-sub-ul li a{display: block; width:100%; height: 100%;}
.nav-sub-ul li a.router-link-active{border-bottom: 3px solid #DE0515;}
.fixedNavbar {
      position: fixed;
      width: 100%;
      z-index: 9;
      top: 89px;
      left: 0;
      padding-bottom: 10px;
      background:#fff
      }
</style>
